import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';
import { IPaymentBillPageParams, IPaymentFundPageParams, IPaymentReceiptPageParams, IPaymentChangePhone, IPaymentFundCount } from '../../../../types/lianlian-manage';

const hostUrl = getHostbaseUrl();

/**
 * 空中分账 - 分账账户 - 付款方管理对账单
 */
export async function queryPaymentBillPageList(params?: IPaymentBillPageParams) {
  let data = [];
  let total = 0;

  try {
    const { code, context, message } = await Http.get<{data: []; total: number}>(`${hostUrl}/pay/payer/bill/page`, params);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: []; total: number };

      data = items || [];
      total = Number(all) || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 空中分账 - 分账账户 - 付款方管理对账单导出
 */

export async function exportPaymentBillPage(params?: IPaymentBillPageParams) {
  let buffer = null as Blob | null;

  try {
    const { code, context, message } = await Http.get<Blob>(
      `${hostUrl}/pay/payer/bill/export`,
      { ...params },
      { responseType: 'blob' },
    );

    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return buffer;
}

/**
 * 空中分账 - 分账账户 - 付款方管理提现记录
 */
export async function queryPaymentCashPageList(page: number, size: number, lianId: string) {
  let data = [];
  let total = 0;

  try {
    const { code, context, message } = await Http.get<{data: []; total: number}>(`${hostUrl}/pay/payer/cash/page`, {
      page,
      size,
      lianId,
    });

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: []; total: number };

      data = items || [];
      total = Number(all) || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 空中分账 - 分账账户 - 付款方管理提现记录导出
 */

export async function exportPaymentCashPage(params) {
  let buffer = null as Blob | null;

  try {
    const { code, context, message } = await Http.get<Blob>(
      `${hostUrl}/pay/payer/cash/export`,
      { ...params },
      { responseType: 'blob' },
    );

    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return buffer;
}

/**
 * 空中分账 - 分账账户 - 付款方管理交易记录分页
 */
export async function queryPaymentFundPageList(params: IPaymentFundPageParams) {
  let data = [];
  let total = 0;

  try {
    const { code, context, message } = await Http.get<{data: []; total: number}>(`${hostUrl}/pay/payer/fund/page`, params);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: []; total: number };

      data = items || [];
      total = Number(all) || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 *  空中分账 - 分账账户 - 付款方管理交易记录统计
 */

export async function queryPaymentFundCount(params: IPaymentFundPageParams) {
  let data = {} as IPaymentFundCount;

  try {
    const { code, context, message } = await Http.get<IPaymentFundCount>(`${hostUrl}/pay/payer/fund/count`, params);

    if (code === EAxiosResponseCode.Succeed) {

      data = context || {} as IPaymentFundCount;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return { data };
}

/**
 *  空中分账 - 分账账户 - 付款方管理交易记录分页导出
 */

export async function exportPaymentFundPage(params: IPaymentFundPageParams) {
  let buffer = null as Blob | null;

  try {
    const { code, context, message } = await Http.get<Blob>(
      `${hostUrl}/pay/payer/fund/export`,
      { ...params },
      { responseType: 'blob' },
    );

    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return buffer;
}

/**
 * 空中分账 - 分账账户 - 付款方管理回单分页
 */
export async function queryPaymentReceiptPageList(params) {
  let data = [];
  let total = 0;

  try {
    const { code, context, message } = await Http.get<{data: []; total: number}>(`${hostUrl}/pay/payer/receipt/page`, params);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: []; total: number };

      data = items || [];
      total = Number(all) || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 *  空中分账 - 分账账户 - 付款方管理回单分页导出
 */

export async function exportPaymentReceiptPage(params: IPaymentReceiptPageParams) {
  let data = '' as string | null;

  try {
    const { code, context, message } = await Http[__ENABLE_DEV_MOCK__ || __MOCK_PROD__ ? 'get' : 'post']<any>(
      `${hostUrl}/pay/payer/receipt/batch-download`,
      { ...params },
    );

    if (code === EAxiosResponseCode.Succeed) {
      data = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 空中分账 - 分账账户 - 修改支付密码
 */
export async function updatePaymentPassword(
  params: {
    password: string;
    newPassword: string;
    lianId: number;
    randomKey: string;
  },
  type: 'payer' | 'payee' | 'agent') {

  try {
    const { code, message } = await Http.post(`${hostUrl}/pay/${type}/lian/update-pay-password`, params);

    if (code !== EAxiosResponseCode.Succeed) {

      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}

/**
 * 空中分账 - 分账账户 - 找回支付密码申请
 */
export async function findPaymentPasswordApply(params: {lianId: number}, type: 'payer' | 'payee' | 'agent') {
  let data = {} as {token: string};

  try {
    const { code, context, message } = await Http.post<{token: string}>(`${hostUrl}/pay/${type}/lian/find-password-apply`, params);

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || {} as {token: string};

      data = res || {} as {token: string};
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
  return data;
}

/**
 * 空中分账 - 分账账户 - 找回支付密码验证
 */
export async function findPaymentPasswordVerify(
  params: {
    password: string;
    code: string;
    lianId: number;
    randomKey: string;
    token: string;
  },
  type: 'payer' | 'payee' | 'agent') {

  try {
    const { code, message } = await Http.post(`${hostUrl}/pay/${type}/lian/find-password-verify`, params);

    if (code !== EAxiosResponseCode.Succeed) {

      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}

/**
 * 空中分账 - 分账账户 - 更换手机号申请
 */
export async function changePaymentPhoneApply(
  params: {
    lianId: number;
    newPhone: string;
    password: string;
    randomKey: string;
}, type: 'payer' | 'payee' | 'agent') {
  let data = {} as IPaymentChangePhone;

  try {
    const { code, context, message } = await Http.post<IPaymentChangePhone>(`${hostUrl}/pay/${type}/lian/change-phone`, params);

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || {} as IPaymentChangePhone;

      data = res || {} as IPaymentChangePhone;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
  return data;
}

/**
 * 空中分账 - 分账账户 - 更换手机号校验
 */
export async function changePaymentPhoneVerify(
  params: {
    lianId: number;
    code: string;
    txnSeqno: number;
    token: string;
}, type: 'payer' | 'payee' | 'agent') {

  try {
    const { code, message } = await Http.post(`${hostUrl}/pay/${type}/lian/change-Phone-verify`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 空中分账 - 分账账户 - 注销付款方账户连连 */
export async function cancelPaymentLian(
  params: {
    lianId: number;
    password: string;
    randomKey: string;
}, type: 'payer' | 'payee' | 'agent') {

  try {
    const { code, message } = await Http.post(`${hostUrl}/pay/${type}/lian/cancel`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 空中分账 - 分账账户 - 提现
 */
export async function payerWithdraw(params) {

  let data = {};

  try {
    const { code, context, message } = await Http.post(`${hostUrl}/pay/payer/withdraw`, params);

    if (code === EAxiosResponseCode.Succeed) {
      const res = context;

      data = res || {};
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
  return data;
}

/**
 * 空中分账 - 分账账户 - 提现二次校验
 */
export async function payerWithdrawWithCode(params) {

  let data = {};

  try {
    const { code, context, message } = await Http.post(`${hostUrl}/pay/payer/withdraw-sms-validate`, params);

    if (code === EAxiosResponseCode.Succeed) {
      const res = context;

      data = res || {};
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
  return data;
}
